module.exports = __webpack_public_path__ + "static/images/team_going_box_title.9d153ea.png";